// While the owner restores a backup, every OTHER logged-in user of the
// company sees this full-screen "please wait" so nobody saves a sale into a
// half-restored database. When the restore ends, they're asked to reload
// (what's on their screen may be from before the restore).

import { createPortal } from 'react-dom';
import { useEffect, useState } from 'react';
import { getClientDb } from '../firebase/clientApp';
import { useAuth } from '../context/AuthContext';
import { watchRestoreLock, type RestoreLock } from '../utils/backup';
import { Button } from './ui';

export default function RestoreGate() {
  const { user } = useAuth();
  const db = getClientDb();
  const [lock, setLock] = useState<RestoreLock | null>(null);
  const [finished, setFinished] = useState(false);

  useEffect(() => {
    if (!db) return;
    let seen = false;
    return watchRestoreLock(db, l => {
      setLock(l);
      if (l) seen = true;
      else if (seen) setFinished(true);
    });
  }, [db]);

  const mine = lock?.byId === user?.id;
  if ((!lock || mine) && !finished) return null;

  return createPortal(
    <div className="modal-overlay" style={{ zIndex: 3000, left: 0 }}>
      <div className="modal" style={{ maxWidth: 420, textAlign: 'center', padding: '28px 24px' }}>
        {finished && !lock ? (
          <>
            <h3 style={{ marginBottom: 8 }}>Data restored</h3>
            <p style={{ color: 'var(--text-2)', fontSize: 13, marginBottom: 20 }}>
              Your company data was put back to an earlier backup. Reload to see it.
            </p>
            <Button variant="primary" onClick={() => window.location.reload()}>Reload</Button>
          </>
        ) : lock && (
          <>
            <div className="spinner" style={{ margin: '0 auto 14px' }} />
            <h3 style={{ marginBottom: 8 }}>Restoring data, please wait</h3>
            <p style={{ color: 'var(--text-2)', fontSize: 13, margin: 0 }}>
              {lock.byName} is putting the company back to a backup. This screen goes away by itself when it's done.
            </p>
          </>
        )}
      </div>
    </div>,
    document.body,
  );
}
